var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7732 0C14.2798 0 13.7911 0.0971967 13.3352 0.286039C12.8793 0.474882 12.4651 0.751673 12.1161 1.10061L1.09005 12.1267C0.942352 12.2744 0.859375 12.4747 0.859375 12.6836V16.884C0.859375 17.319 1.21199 17.6716 1.64695 17.6716H5.84736C6.05624 17.6716 6.25656 17.5886 6.40426 17.4409L16.3641 7.48107C16.3697 7.47575 16.3753 7.47033 16.3808 7.46481C16.3863 7.45929 16.3918 7.45371 16.3971 7.44807L17.4303 6.41482C17.7793 6.06588 18.0561 5.65164 18.2449 5.19573C18.4337 4.73982 18.5309 4.25118 18.5309 3.75771C18.5309 3.26425 18.4337 2.77561 18.2449 2.3197C18.0561 1.86379 17.7793 1.44954 17.4303 1.10061C17.0814 0.751673 16.6671 0.474882 16.2112 0.286039C15.7553 0.0971967 15.2667 0 14.7732 0ZM15.8237 5.79387L16.3165 5.30102C16.5192 5.09835 16.68 4.85774 16.7897 4.59294C16.8993 4.32815 16.9558 4.04433 16.9558 3.75771C16.9558 3.47109 16.8993 3.18728 16.7897 2.92248C16.68 2.65768 16.5192 2.41708 16.3165 2.21441C16.1139 2.01174 15.8733 1.85098 15.6085 1.74129C15.3437 1.63161 15.0598 1.57515 14.7732 1.57515C14.4866 1.57515 14.2028 1.63161 13.938 1.74129C13.6732 1.85098 13.4326 2.01174 13.2299 2.21441L12.7371 2.70726L15.8237 5.79387ZM11.6233 3.82106L2.43453 13.0098V16.0964H5.52114L14.7099 6.90767L11.6233 3.82106Z",
    fill: "#3E3E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlackIcon);
export default __webpack_public_path__ + "static/media/edit-black-icon.0bf0d186d0253e594758ed6f707ffcbe.svg";
export { ForwardRef as ReactComponent };